<template>
  <v-container
    fill-height
    fluid
  >
    <v-layout
      justify-center
      align-center
    >
      <v-flex
        column
        lg4
        align-self-center>
        <material-card
          color="green"
          :title="$t('Pages.EmailConfirmation.title')"
          :text="$t('Pages.EmailConfirmation.subtitle')"
        >
          <v-card-text>

            <v-alert
              v-if="success && text != ''"
              :value="true"
              type="success"
            >
              {{ text }}
              <router-link
                to="/" class="white--text">
                {{$t('Pages.EmailConfirmation.proceed_to_login')}}
              </router-link>
            </v-alert>

            <v-alert
              v-if="!success && text != ''"
              :value="true"
              type="error"
            >
              {{ text }}
            </v-alert>

          </v-card-text>
        </material-card>

        <v-layout
          justify-center
          align-center
        >
          <v-flex
            lg12
            class="text-lg-right">
            <router-link
              to="/"
              class="tertiary--text">
              {{$t('Pages.Login.title')}}
            </router-link>&nbsp;·&nbsp;
            <router-link
              to="/forgot/password"
              class="tertiary--text">
              {{$t('Pages.ForgotPassword.title')}}
            </router-link>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  data: () => ({
    text: '',
    success: true
  }),
  created(){
      this.confirmEmail();
  },
  methods: {
      confirmEmail(){
          let self = this;
          this.setFetching(true);
          this.repositories.auth.confirmEmail(this.$route.params.token).then(response => {
              self.success = true;
              self.text = response.data.message;
          }).catch(function(response){
              self.success = false;
              self.text = response.data.message;
          }).finally(() => {
              this.setFetching(false);
          });
      }
  }
}
</script>

<style lang="scss">

</style>
